import React from 'react';
import PropTypes from 'prop-types';

import styles from './styles.module.scss';
import Timer from '../../../../Utils/Timer';
import useQuerySummaryPayments from '../hooks/useQuerySummaryPayments';
import BoxInfo, { RowBoxInfo } from '../../../../components/DS/BoxInfo/BoxInfo';
import { currencyFormatter } from '../../../../Utils/formats';

const TextItem = ({ title, amount }) => {
  return (
    <div className={styles.textItem}>
      <div className='k-ds-heading-02'>{amount}</div>
      {title}
    </div>
  );
};

TextItem.propTypes = {
  title: PropTypes.string,
  amount: PropTypes.string,
};

export const Period = ({ startDate, endDate }) => {
  if (!startDate || !endDate) {
    return '';
  }

  const FORMAT_DATE = 'd \'de\' MMMM \'del\' yyyy';
  if (Timer().diff(startDate, endDate, 'day').days === 0) {
    return Timer().toLocal(startDate, FORMAT_DATE);
  }

  if (Timer().toLocal(startDate, 'L') === Timer().toLocal(endDate, 'L')) {
    const endDay = Timer().toLocal(endDate, 'd');
    const startDateFormant = Timer().toLocal(
      startDate,
      // eslint-disable-next-line no-useless-escape
      `d \'al\' ${endDay} \'de\' MMMM \'del\' yyyy`
    );

    return startDateFormant;
  }

  return (
    <>
      <div>{`${Timer().toLocal(startDate, FORMAT_DATE)} al`}</div>
      <div>{`${Timer().toLocal(endDate, FORMAT_DATE)}`}</div>
    </>
  );
};

Period.propTypes = {
  startDate: PropTypes.string,
  endDate: PropTypes.string,
};

const SALES = [
  {
    title: 'Ventas totales:',
    content: '',
    amount: '',
  },
];

const TRANSACTION_CANCEL = [
  {
    title: 'Cancelaciones:',
    content: '',
    amount: '',
  },
];

const PaymentSummary = ({ startDate, endDate }) => {
  const { data } = useQuerySummaryPayments({
    startDateRange: Timer().toLocal(startDate),
    endDateRange: Timer().toLocal(endDate),
  });

  return (
    <div className={styles.paymentSummary}>
      <BoxInfo
        color='green'
        header={{
          title: 'Ventas',
          subTitle: <Period startDate={startDate} endDate={endDate} />,
        }}
      >
        {SALES.map(item => (
          <RowBoxInfo
            key={item.title}
            text={
              <TextItem
                title={item.title}
                amount={data?.payments_count.toLocaleString()}
              />
            }
            content={currencyFormatter(data?.payments_total || 0)}
          />
        ))}
      </BoxInfo>
      <BoxInfo
        color='red'
        header={{
          title: 'Cancelaciones',
          subTitle: <Period startDate={startDate} endDate={endDate} />,
        }}
      >
        {TRANSACTION_CANCEL.map(item => (
          <RowBoxInfo
            key={item.title}
            text={
              <TextItem
                title={item.title}
                amount={data?.cancelations_count.toLocaleString()}
              />
            }
            content={currencyFormatter(data?.cancelations_total || 0)}
          />
        ))}
      </BoxInfo>
    </div>
  );
};

PaymentSummary.propTypes = {
  startDate: PropTypes.string,
  endDate: PropTypes.string,
};

export default PaymentSummary;
